function branchMessageOptionAndChildBranchConditionMismatchCheck(config, whatsappVariables = null) {
    function checkJsonErrors(json) {

        function escapeRegExp(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }

        // Extract the clean value from the condition string: "^A\\b" -> "A", "^YES\\b" -> "YES", "^A2\\b" -> "A2"
        function extractConditionValue(condition) {
            if (!condition) return "";
            let clean = condition.replace(/^\^/, '').replace(/(\\b|\$)$/, '');
            return clean.trim().toUpperCase();
        }

        const optionMissingFromMessageErrors = [];
        const childBranchMissingErrors = [];

        function checkBranchForMismatch(branchKey) {
            let message = branchKey === "initial" ? json?.message : json[branchKey]?.message || "";

            // WhatsApp variable replacement
            if (whatsappVariables && message) {
                Object.entries(whatsappVariables).forEach(([key, value]) => {
                    const variablePattern = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
                    message = message.replace(variablePattern, String(value || ''));
                });
            }

            // Get all child branches
            const configuredOptions = new Set();
            for (const key in json) {
                const parentKey = json[key]?.parent;
                const isChildOfCurrent = branchKey === "initial" ? parentKey === null : parentKey === branchKey;

                if (isChildOfCurrent && key.startsWith("branch") && json[key]?.condition !== ".*") {
                    const val = extractConditionValue(json[key]?.condition);
                    if (val) configuredOptions.add(val);
                }
            }

            // Check do the configured branches appear in the text
            // If the branch is "YES", finding "Yes," or "Yes" is enough.
            configuredOptions.forEach(option => {
                const looseCheckRegex = new RegExp(`(?:\\s|^|\\()${escapeRegExp(option)}(?=[\\s\\.\\,\\)\\:\\-\\!\\?]|\$)`, 'i');

                if (!looseCheckRegex.test(message)) {
                    optionMissingFromMessageErrors.push({
                        "branch": branchKey,
                        "option": option,
                        "message": `Branch condition '${option}' is defined, but not found in the text.`
                    });
                }
            });

            // Check does the text contain lists/options not in config?
            // Only flag "A.", "1)", "B:"
            const strictOptionRegex = /(?:^|\s)(?:\()?([A-Z0-9]{1,3})(?:[\.\)\:\-])(?=\s|$)/gi;

            let match;
            while ((match = strictOptionRegex.exec(message)) !== null) {
                const foundOptionInText = match[1].toUpperCase();

                if (!configuredOptions.has(foundOptionInText)) {
                    childBranchMissingErrors.push({
                        "branch": branchKey,
                        "option": foundOptionInText,
                        "message": `Text contains option '${foundOptionInText}' but no matching branch exists.`
                    });
                }
            }
        }

        checkBranchForMismatch("initial");
        for (const key in json) {
            if (key.startsWith("branch")) {
                checkBranchForMismatch(key);
            }
        }

        return {
            missingChildErrors: childBranchMissingErrors,
            missingOptionsErrors: optionMissingFromMessageErrors
        };
    }

    const errors = checkJsonErrors(config);
    return errors;
}

export function checkSurveyDataForBranchErrors(data, whatsappVariables = null) {
    const config = data?.config;
    if (config) {
        return branchMessageOptionAndChildBranchConditionMismatchCheck(config, whatsappVariables);
    }
    return [];
}

export function getErrorsByBranch(errorObject, branchName) {
    const errors = {
        missingChildErrors: [],
        missingOptionsErrors: []
    };

    if (errorObject?.missingChildErrors?.length) {
        errors.missingChildErrors = errorObject.missingChildErrors.filter(error => error.branch === branchName);
    }

    if (errorObject?.missingOptionsErrors?.length) {
        errors.missingOptionsErrors = errorObject.missingOptionsErrors.filter(error => error.branch === branchName);
    }

    return errors;
}